import axios from 'axios';
import find from 'lodash/find';
import reduce from 'lodash/reduce';

import client from './client';

export const fetchGuilds = async () => {
  try {
    const guilds = await client.get('/guilds');

    if (guilds.data && guilds.data.length) {
      const subscription = await axios.get(`${process.env.NEXT_PUBLIC_TELEGRAM_BOT_API_URL}/subscription`, {
        params: { guilds: guilds.data.map(e => e.id)},
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });

      return reduce(subscription?.data, (res, subscription) => {
        return [
          ...res,
          { ...find(guilds.data, e => e.id === subscription.guild_id) || {}, ...subscription }
        ]
      }, [])
    }

    return [];
  } catch (e) {
    return e
  }
}
